import { React, useEffect, useState, useRef } from "react";
import { useGlobalContext } from "../context";
import "./GameDetails.css";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { FiSettings } from "react-icons/fi";
import { FaRegLightbulb, FaSkullCrossbones, FaSkull } from "react-icons/fa";
import { FcIdea } from "react-icons/fc";
import { generateStartPosition } from "../helpers/chess960Helpers";
let futureMoves = [];
let stockfish = new Worker("stockfish11.js");
let stockfishTmp = new Worker("stockfish11.js");
let lozza = new Worker("lozza.js");

const Chess = require("chess.js");

const GameDetails = ({ chess, isTraining = false, chess960 = false }) => {
  const {
    pgn,
    setPgn,
    isGameOver,
    setIsGameOver,
    fen,
    setFen,
    letRedo,
    setLetRedo,
    setResetBoard,
    resetBoard,
    piecesColor,
    setShowSidebar,
    stockfishDepth,
    stockfishEvaluation,
    setStockfishEvaluation,
    showStockfishEvaluation,
    setMateSoon,
    showMaterialInfo,
    startPosition,
    boardOrientation,
    setBestMove,
    bestMove,
    setBestMoveCoords,
    setShowBestMove,
    size,
    setShowColorPicker,
    engineStrength,
    lozzaDepth,
    showLozzaEvaluation,
    showVariants,
    setNewChess960Game,
  } = useGlobalContext();

  const [positionInfo, setPositionInfo] = useState({
    material: "",
    evaluation: "",
    lastMove: "",
    variants: "",
  });
  const [bestMoveInfo, setBestMoveInfo] = useState("");

  if (!letRedo) {
    futureMoves = [];
  }

  const [firstPosition, setFirstPosition] = useState("");
  useEffect(() => {
    chess.load(startPosition);
    setFirstPosition(chess.fen());
  }, []);

  // show previous half move
  const handleUndo = () => {
    if (chess.history().length > 0) {
      setTimeout(() => {
        futureMoves.push(chess.history({ verbose: true }).pop());
        chess.undo();
        setFen(chess.fen());
      }, 20);
    }
  };

  // show next half move
  const handleRedo = () => {
    if (futureMoves.length !== 0) {
      let tmpMove = futureMoves.pop();
      setTimeout(() => {
        chess.move({ from: tmpMove.from, to: tmpMove.to });
        setFen(chess.fen());
      }, 20);
    }
  };

  const transformVariants = (variants) => {
    if (variants) {
      let x = "";
      variants.map((item, index) => {
        if (index < 8) {
          if (index % 2 === 0) {
            x += +" " + index / 2 + 1 + ". " + item + " ";
          } else {
            x += item + " ";
          }
        }
      });
      return x;
    }
    return "";
  };

  // get infomation about current position from api
  const [lastEvaluation, setLastEvaluation] = useState("0.0");
  const [lastVariant, setLastVariant] = useState("");
  const getEvaluation = () => {
    let lastMove;
    let prevEvaluation;
    let currEvaluation = stockfishEvaluation;

    if (currEvaluation.toString().indexOf("M") > -1) {
      currEvaluation.charAt(0) === "-"
        ? (currEvaluation = "-30.0")
        : (currEvaluation = "30.0");
    }

    if (lastEvaluation.toString().indexOf("M") > -1) {
      lastEvaluation.charAt(0) === "-"
        ? (prevEvaluation = "-30.0")
        : (prevEvaluation = "30.0");
    } else {
      prevEvaluation = lastEvaluation;
    }

    if (!chess.history()[chess.history().length - 1]) {
      lastMove = "";
    } else {
      lastMove = chess.history()[chess.history().length - 1];
    }
    fetch("https://chess-tutor-api.herokuapp.com/evaluation/", {
      method: "POST",
      credentials: "omit",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fen: fen,
        engine_value_after_move: currEvaluation,
        last_move_played: lastMove,
        engine_value_before_move: prevEvaluation,
        variant_before: transformVariants(lastVariant),
        variant_after: transformVariants(variants.v1),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (
          isTraining ||
          fen === "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
        ) {
          setPositionInfo({
            material: data.description,
            evaluation: data.position_evaluation,
            lastMove: data.decode_last_move,
            variants: data.show_variations,
          });
        } else {
          if (turnToPlay === piecesColor) {
            if (!piecesColor && chess.history().length < 2) {
              setPositionInfo({
                material: data.description,
                evaluation: data.position_evaluation,
                lastMove: "",
                variants: "",
              });
            } else {
              setPositionInfo({
                ...positionInfo,
                material: data.description,
                evaluation: data.position_evaluation,
              });
            }
          } else {
            setPositionInfo({
              material: data.description,
              evaluation: data.position_evaluation,
              lastMove: data.decode_last_move,
              variants: data.show_variations,
            });
          }
        }
        // console.log(
        //   "fen: " +
        //     fen +
        //     "\n" +
        //     "stockfish: " +
        //     stockfishEvaluation +
        //     "\n" +
        //     "last move: " +
        //     chess.history()[chess.history().length - 1] +
        //     "\n" +
        //     "stockfish_before: " +
        //     lastEvaluation +
        //     "\n" +
        //     "last_variant" +
        //     lastVariant +
        //     "\n" +
        //     "curr_variant:" +
        //     variants.v1
        // );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [variants, setVariants] = useState({
    v1: ["..."],
    v2: ["..."],
    v3: ["..."],
  });

  // get variants
  const getVariants = (info) => {
    info = info.split(" ");

    return info.slice(
      info.findIndex((item) => item === "pv") + 1,
      info.findIndex((item) => item === "bmc")
    );
  };

  const displayVariant = (variants) => {
    if (variants) {
      let transformedVariant = transformVariants(variants);
      return <p>{transformedVariant}</p>;
    }
    return <p></p>;
  };

  let bestMoveBtnRef = useRef();
  const [turnToPlay, setTurnToPlay] = useState(1);

  useEffect(() => {
    getEvaluation();
  }, [stockfishEvaluation]);

  // get Stockfish evaluation
  useEffect(() => {
    let variant1 = ["..."];
    let variant2 = ["..."];
    let variant3 = ["..."];
    let turn = chess.turn();

    setTimeout(() => {
      setBestMoveInfo("");
      setThreat("");
    }, 100);

    stockfishEvaluation !== "-" && stockfishEvaluation !== ""
      ? setLastEvaluation(stockfishEvaluation)
      : setLastEvaluation("0.0");

    setLastVariant(variants.v1);

    chess.turn() === "w" ? setTurnToPlay(1) : setTurnToPlay(0);

    bestMoveBtnRef.current.setAttribute("disabled", "disabled");
    const setEvaluation = (evalvalue) => {
      if (turn === "w") {
        return evalvalue;
      }
      return -evalvalue;
    };
    stockfish.postMessage("uci");
    stockfish.postMessage(`setoption name UCI_Chess960 value ${chess960}`);
    stockfish.postMessage("ucinewgame");
    stockfish.postMessage(`position fen ${fen}`);
    stockfish.postMessage(`go depth ${stockfishDepth} seldepth`);
    stockfish.onmessage = (e) => {
      let data = JSON.stringify(e.data);
      let dataPom = data;
      if (dataPom.startsWith('"info depth 6 seldepth')) {
        variant1 = getVariants(dataPom);
      }
      if (dataPom.startsWith('"info depth 8 seldepth')) {
        variant2 = getVariants(dataPom);
      }
      if (dataPom.startsWith('"info depth 10 seldepth')) {
        variant3 = getVariants(dataPom);
      }
      setVariants({ v1: variant1, v2: variant2, v3: variant3 });
      if (data.match(`info depth ${stockfishDepth} seldepth`)) {
        data = data.split(" ");
        let cpIndex = data.findIndex((item) => item === "cp") + 1;
        if (cpIndex !== 0) {
          setMateSoon(null);
          let value = setEvaluation(data[cpIndex]);
          value >= 0
            ? setStockfishEvaluation(`+${value / 100}`)
            : setStockfishEvaluation(value / 100);
        } else {
          let mateIndex = data.findIndex((item) => item === "mate") + 1;
          let value = setEvaluation(data[mateIndex]);
          if (value > 0) {
            setStockfishEvaluation(`${value}M`);
            setMateSoon(1);
          } else {
            setStockfishEvaluation(`-${value * -1}M`);
            setMateSoon(0);
          }
        }
        const moveIndex = data.findIndex((item) => item === "pv") + 1;
        const moveCoords = data[moveIndex].split("");
        setBestMove({
          fromX: moveCoords[0],
          fromY: moveCoords[1],
          toX: moveCoords[2],
          toY: moveCoords[3],
        });
        // getEvaluation();
        setTimeout(() => {
          if (bestMoveBtnRef.current) {
            bestMoveBtnRef.current.removeAttribute("disabled");
          }
        }, 200);
      }
    };
  }, [
    fen,
    setStockfishEvaluation,
    chess,
    piecesColor,
    stockfishDepth,
    setMateSoon,
  ]);

  const [lozzaEvaluation, setLozzaEvaluation] = useState("+0.0");
  useEffect(() => {
    let turn = chess.turn();
    if (!chess.game_over()) {
      let fen = chess.fen();
      lozza.postMessage("uci");
      lozza.postMessage("ucinewgame");
      lozza.postMessage(`position fen ${fen}`);
      lozza.postMessage(`go depth ${lozzaDepth}`);
      lozza.onmessage = (e) => {
        let data = JSON.stringify(e.data);
        if (data.includes("mate")) {
          data = data.split(" ");
          let mateIndex = data.findIndex((item) => item === "mate") + 1;
          let value = parseInt(data[mateIndex]) + 1;
          if (turn === "w") {
            setLozzaEvaluation(`${value}M`);
          } else {
            setLozzaEvaluation(`-${-1 * value}M`);
          }
        }
        if (data.includes(`depth ${lozzaDepth} seldepth`)) {
          data = data.split(" ");
          let cpIndex = data.findIndex((item) => item === "cp") + 1;
          if (cpIndex > 0) {
            let value = parseFloat(data[cpIndex]) / 100;
            if (turn === "w") {
              value >= 0
                ? setLozzaEvaluation(`+${value}`)
                : setLozzaEvaluation(`${value}`);
            } else {
              value >= 0
                ? setLozzaEvaluation(`${-value}`)
                : setLozzaEvaluation(`+${-value}`);
            }
          }
        }
      };
    }
  }, [
    fen,
    setStockfishEvaluation,
    chess,
    piecesColor,
    stockfishDepth,
    setMateSoon,
  ]);

  // get info about best move
  const getBestMoveInfo = () => {
    let chessTmp = new Chess(fen);
    chessTmp.move({
      from: bestMove.fromX + bestMove.fromY,
      to: bestMove.toX + bestMove.toY,
      promotion: "q",
    });
    let move1;
    move1 = chessTmp.pgn().split(" ");
    move1 = move1[move1.length - 1];
    let variantAfterMove = variants.v3;
    variantAfterMove.shift();
    variantAfterMove = transformVariants(variantAfterMove);
    let fenTmp = chessTmp.fen().split(" ");
    fenTmp[1] = chess.turn();
    fenTmp = fenTmp.join(" ");
    let move2;
    stockfishTmp.postMessage("uci");
    stockfish.postMessage(`setoption name UCI_Chess960 value ${chess960}`);
    stockfishTmp.postMessage("ucinewgame");
    stockfishTmp.postMessage(`position fen ${fenTmp}`);
    stockfishTmp.postMessage(`go depth ${stockfishDepth}`);
    stockfishTmp.onmessage = (e) => {
      let data = JSON.stringify(e.data);
      if (data.match(`bestmove`)) {
        move2 = data.split(" ")[1].replace(/[^a-z0-9]/gi, "");
        if (move1 && move2) {
          chessTmp.load(fen);
          let pieceType = chessTmp.get(bestMove.fromX + bestMove.fromY);
          chessTmp.remove(bestMove.fromX + bestMove.fromY);
          chessTmp.put(pieceType, bestMove.toX + bestMove.toY);
          setTimeout(() => {
            chessTmp.move({
              from: move2.slice(0, 2),
              to: move2.slice(2, 4),
              promotion: "q",
            });
            move2 = chessTmp.history()[0];
            fetch(
              "https://chess-tutor-api.herokuapp.com/best_move_description/",
              {
                method: "POST",
                credentials: "omit",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  move1: move1,
                  move2: move2,
                  variant: variantAfterMove,
                }),
              }
            )
              .then((response) => response.json())
              .then((data) => {
                setBestMoveInfo(data.explanation);
              });
          }, 100);
        }
      }
    };
  };

  const [threat, setThreat] = useState("");
  const getThreat = () => {
    let variant_threat;
    let move_threat;
    let evaluation;
    let chessTmp = new Chess(fen);
    let fenTmp = chessTmp.fen().split(" ");
    chess.turn() === "w" ? (fenTmp[1] = "b") : (fenTmp[1] = "w");
    fenTmp = fenTmp.join(" ");
    stockfishTmp.postMessage("uci");
    stockfishTmp.postMessage("ucinewgame");
    stockfishTmp.postMessage(`position fen ${fenTmp}`);
    stockfishTmp.postMessage(`go depth ${stockfishDepth}`);
    stockfishTmp.onmessage = (e) => {
      let data = JSON.stringify(e.data);
      if (data.match(`"info depth ${stockfishDepth} seldepth`)) {
        let info = data.split(" ");
        let index = info.findIndex((item) => item === "cp");
        if (index !== 0) {
          evaluation = info.slice(
            index + 1,
            info.findIndex((item) => item === "nodes")
          );
          evaluation >= 0
            ? (evaluation = `+${evaluation / 100}`)
            : (evaluation = evaluation / 100);
        } else {
          evaluation = info.slice(
            info.findIndex((item) => item === "mate") + 1,
            info.findIndex((item) => item === "nodes")
          );
          evaluation >= 0
            ? (evaluation = `${evaluation}M`)
            : (evaluation = `-${evaluation * -1}M`);
        }
        variant_threat = transformVariants(getVariants(data));
      }
      if (data.match(`bestmove`)) {
        move_threat = data.split(" ")[1].replace(/[^a-z0-9]/gi, "");
        fetch("https://chess-tutor-api.herokuapp.com/threats_description/", {
          method: "POST",
          credentials: "omit",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            move_threat: move_threat,
            evaluation_threat: evaluation,
            variant_threat: variant_threat,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            setThreat(data.describe_threat);
          });
      }
    };
  };

  const showBestMoveOnTheBoard = () => {
    getBestMoveInfo();
    bestMoveBtnRef.current.setAttribute("disabled", "disabled");

    const coordsHor = ["a", "b", "c", "d", "e", "f", "g", "h"];
    const coordsVert = ["1", "2", "3", "4", "5", "6", "7", "8"];

    const findCoordIndex = (hor, vert) => {
      const horIndex = coordsHor.findIndex((item) => item === hor);
      const vertIndex = coordsVert.findIndex((item) => item === vert);

      if (boardOrientation === "white") {
        setBestMoveCoords({
          x: horIndex * (size / 8),
          y: (7 - vertIndex) * (size / 8),
        });
      } else {
        setBestMoveCoords({
          x: (7 - horIndex) * (size / 8),
          y: vertIndex * (size / 8),
        });
      }
    };

    if (
      isTraining ||
      (!isTraining && chess.turn() === "w" && piecesColor) ||
      (!isTraining && chess.turn() === "b" && !piecesColor)
    ) {
      setTimeout(() => {
        findCoordIndex(bestMove.fromX, bestMove.fromY);
        setShowBestMove(true);
      }, 550);

      setTimeout(() => {
        findCoordIndex(bestMove.toX, bestMove.toY);
      }, 1050);

      setTimeout(() => {
        setShowBestMove(false);
        if (bestMoveBtnRef.current) {
          bestMoveBtnRef.current.removeAttribute("disabled");
        }
      }, 1550);
    }
  };

  const refactorPgn = (pgn) => {
    if (pgn.startsWith("[")) {
      pgn = pgn.replace('SetUp "1"', "Ustawiono pozycję początkową");
    }
    return <p>{pgn}</p>;
  };

  return (
    <div className="details-container">
      <div className="details-btns">
        <button
          ref={bestMoveBtnRef}
          className="btn btn-blue details-btn hint-btn"
          onClick={() => showBestMoveOnTheBoard()}
        >
          <FaRegLightbulb />
        </button>
        <button
          disabled={isGameOver || chess960}
          id="prevBtn"
          className="btn btn-blue details-btn details-btn-bigger"
          onClick={() => {
            setLetRedo(true);
            handleUndo();
          }}
        >
          <MdKeyboardArrowLeft />
        </button>
        <button
          disabled={isGameOver || chess960}
          id="nextBtn"
          className="btn btn-blue details-btn details-btn-bigger"
          onClick={() => {
            if (!letRedo) {
              futureMoves = [];
            }
            handleRedo();
          }}
        >
          <MdKeyboardArrowRight />
        </button>
        <button
          className="btn btn-blue details-btn"
          onClick={() => {
            if (chess960) {
              chess.load(generateStartPosition());
              setNewChess960Game(true);
              setFen(chess.fen());
            } else {
              chess.reset();
              setFen(chess.fen());
              futureMoves = [];
              setPgn(chess.pgn());
            }
            setResetBoard(!resetBoard);
            setIsGameOver(false);
          }}
        >
          <span className="details-btn-text">nowa partia</span>
        </button>
        <button
          className="btn btn-blue details-btn"
          onClick={() => setShowSidebar(true)}
        >
          <FiSettings />
        </button>
      </div>
      <div className="all-details" style={{ height: `${size - 50}px` }}>
        {isGameOver && (
          <div>
            <h2 className="game-over-info">Gra zakończona</h2>
          </div>
        )}

        <div className="game-details">
          <p>{chess.turn() === "w" ? "Ruch białych" : "Ruch czarnych"}</p>
          <p style={isTraining ? {} : { display: "none" }}>Traning szachowy</p>
          <p style={!isTraining && !chess960 ? {} : { display: "none" }}>
            Wariant klasyczny (vs. {engineStrength} elo)
          </p>
          <p style={chess960 ? {} : { display: "none" }}>
            Wariant 960 (vs. {engineStrength} elo)
          </p>
        </div>
        <div
          className="position-info best-move-info"
          style={!isGameOver && bestMoveInfo ? {} : { display: "none" }}
        >
          <div className="best-move-icon">
            <FcIdea />
          </div>
          <p style={{ whiteSpace: "pre-line" }}>{bestMoveInfo}</p>
        </div>
        <div
          className="position-info"
          style={
            !isGameOver && showMaterialInfo && positionInfo.material
              ? {}
              : { display: "none" }
          }
        >
          {positionInfo.material && (
            <div className="single-position-info">
              <h5 className="position-text-header">Materiał:</h5>
              <p className="position-text">{positionInfo.material}</p>
            </div>
          )}
          {positionInfo.evaluation && pgn.length > 0 && fen != firstPosition && (
            <div className="single-position-info">
              <h5 className="position-text-header">Opis aktualnej pozycji:</h5>
              <p className="position-text">{positionInfo.evaluation}</p>
            </div>
          )}
          {positionInfo.lastMove &&
            futureMoves.length === 0 &&
            pgn.length > 0 &&
            fen != firstPosition && (
              <div className="single-position-info">
                <div className="threats-container">
                  <h5 className="position-text-header">
                    Ocena ostatniego ruchu:{" "}
                  </h5>
                  {isTraining && (
                    <div className="show-threats" onClick={() => getThreat()}>
                      <FaSkullCrossbones />
                      <h5>Pokaż groźby</h5>
                    </div>
                  )}
                </div>
                {<p className="position-text">{positionInfo.lastMove}</p>}

                <p className="position-text">{positionInfo.variants}</p>
              </div>
            )}
        </div>
        <div
          className="position-info best-move-info"
          style={
            !isGameOver && showMaterialInfo && threat ? {} : { display: "none" }
          }
        >
          <div className="best-move-icon">
            <FaSkull className="threat-icon" />
          </div>
          <p style={{ whiteSpace: "pre-line" }}>{threat}</p>
        </div>
        {(showStockfishEvaluation || showLozzaEvaluation || showVariants) && (
          <div
            className="stockfish-evaluation-container"
            style={!isGameOver ? {} : { display: "none" }}
          >
            {(showStockfishEvaluation || showLozzaEvaluation) && (
              <div className="stockfish-evaluation-header">
                <p>ewaluacja</p>
                <p>silnik</p>
                <p className="align-right">głębia analizy</p>
              </div>
            )}
            {showStockfishEvaluation && (
              <div className="single-stockfish-evaluation">
                <p>{stockfishEvaluation}</p>
                <p>Stockfish</p>
                <p className="align-right">{stockfishDepth}</p>
              </div>
            )}
            {showLozzaEvaluation && (
              <div className="single-stockfish-evaluation">
                <p>{lozzaEvaluation}</p>
                <p>Lozza</p>
                <p className="align-right">{lozzaDepth}</p>
              </div>
            )}
            {showVariants && (
              <div className="variants">{displayVariant(variants.v1)}</div>
            )}
            {showVariants && (
              <div className="variants">{displayVariant(variants.v2)}</div>
            )}
            {showVariants && (
              <div className="variants">{displayVariant(variants.v3)}</div>
            )}
          </div>
        )}
        <div className="pgn">{refactorPgn(pgn)}</div>
      </div>
      {isTraining && !isGameOver && (
        <button
          className="btn training-btn"
          onClick={() => {
            setShowColorPicker(true);
          }}
        >
          Rozpocznij grę od tej pozycji
        </button>
      )}
    </div>
  );
};

export default GameDetails;
